export function isCompleteShadingReportData(report) {
  return Boolean(
    report &&
    Array.isArray(report.panelMetrics) &&
    report.monthlyPanelMetrics &&
    typeof report.monthlyPanelMetrics === 'object' &&
    Object.keys(report.monthlyPanelMetrics).length > 0 &&
    report.canvas2DJPG &&
    report.canvas3DJPG1 &&
    report.canvas3DJPG2
  );
}

function stableSerialize(value) {
  if (Array.isArray(value)) return value.map(stableSerialize);
  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = stableSerialize(value[key]);
        return acc;
      }, {});
  }
  return value;
}

function selectedPanelSignature(selectedPanels = {}) {
  if (!selectedPanels || typeof selectedPanels !== 'object') return {};
  return Object.keys(selectedPanels)
    .sort()
    .reduce((acc, key) => {
      const panels = Array.isArray(selectedPanels[key])
        ? selectedPanels[key]
        : [];
      acc[key] = panels.map((panel) => Number(panel || 0));
      return acc;
    }, {});
}

function designSignature(design = [], designData = {}) {
  const segments = Array.isArray(designData?.segments)
    ? designData.segments
    : [];
  return (Array.isArray(design) ? design : []).map((roof, idx) => {
    const segment = segments[idx] || {};
    return {
      id: roof?.id ?? null,
      panels: Array.isArray(roof?.panels) ? roof.panels : null,
      vertical: roof?.vertical ?? null,
      horizontal: roof?.horizontal ?? null,
      pitch: segment?.pitch ?? roof?.pitch ?? null,
      azimuth: segment?.azimuth ?? roof?.azimuth ?? null,
      geometry: segment?.geometry ?? roof?.geometry ?? null,
      acMonthly: Array.isArray(roof?.acMonthly) ? roof.acMonthly : null,
      solarAccess: segment?.solarAccess ?? segment?.solar_access ?? null,
      tsrf: segment?.tsrf ?? segment?.TSRF ?? null,
      tof: segment?.tof ?? segment?.TOF ?? null
    };
  });
}

function canvasShadingSignature(state = {}) {
  const designData = state.designData || {};
  return {
    shadingRevision:
      state.shadingRevision ??
      state.shadingCacheKey ??
      designData.shadingRevision ??
      designData.shading_cache_key ??
      designData.shading_images ??
      null,
    obstacles: designData.obstacles ?? state.obstacles ?? null,
    trees: designData.trees ?? state.trees ?? null,
    panelShadings: state.panelShadings ?? designData.panel_shadings ?? null
  };
}

export function createProposalShadingReportSignature(state = {}) {
  return JSON.stringify(
    stableSerialize({
      selectedPanels: selectedPanelSignature(state.selectedPanels),
      design: designSignature(state.design, state.designData),
      canvasShading: canvasShadingSignature(state),
      panelId: state.panel?.id ?? state.panel ?? null,
      panelPower: state.panel?.power ?? null,
      totalPanels: state.totalPanels ?? null,
      systemSize: state.systemSize ?? null,
      dcAcRatio: state.dcAcRatio ?? null
    })
  );
}

function nearlyEqual(a, b, tolerance = 0.001) {
  const left = Number(a);
  const right = Number(b);
  if (!Number.isFinite(left) || !Number.isFinite(right)) return true;
  return Math.abs(left - right) <= tolerance;
}

export function isReusableShadingReportData(report, state = {}) {
  if (!isCompleteShadingReportData(report)) return false;

  if (report.proposalStateSignature) {
    return (
      report.proposalStateSignature ===
      createProposalShadingReportSignature(state)
    );
  }

  if (!nearlyEqual(report.totalPanels, state.totalPanels, 0)) return false;
  if (!nearlyEqual(report.systemSize, state.systemSize, 0.001)) return false;
  if (!nearlyEqual(report.dcAcRatio, state.dcAcRatio, 0.01)) return false;

  return true;
}
